/*
 * Keeps the sticky header-group sections stacked correctly.
 *
 * The header and the countdown timer bar are pinned with hard-coded offsets
 * (header top: 38px, timer top: 110px). Those assume a fixed header height, so
 * as soon as the page is scrolled the header — which has a much higher z-index —
 * covers the top few pixels of the red countdown bar.
 *
 * This measures the real height of each sticky/fixed section in the header group
 * and sets each following section's `top` to sit directly underneath it.
 */
(function () {
  var GROUP_SELECTOR = '.shopify-section-group-header-group';

  function updateOffsets() {
    var sections = document.querySelectorAll(GROUP_SELECTOR);
    if (!sections.length) return;

    var offset = 0;

    sections.forEach(function (section) {
      var position = window.getComputedStyle(section).position;

      if (position !== 'sticky' && position !== 'fixed') return;

      // A fixed section is already pinned to the top; it only adds to the stack.
      if (position === 'sticky') {
        section.style.top = offset + 'px';
      }

      offset += section.offsetHeight;
    });
  }

  function scheduleUpdate() {
    window.requestAnimationFrame(updateOffsets);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate);
  } else {
    scheduleUpdate();
  }

  window.addEventListener('load', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('orientationchange', scheduleUpdate);

  // Section heights change when the theme editor re-renders a section, when web
  // fonts land, or when the announcement slider swaps to a taller slide.
  if ('ResizeObserver' in window) {
    var observer = new ResizeObserver(scheduleUpdate);
    document.querySelectorAll(GROUP_SELECTOR).forEach(function (section) {
      observer.observe(section);
    });
  }

  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('shopify:section:unload', scheduleUpdate);
  document.addEventListener('shopify:section:reorder', scheduleUpdate);
})();
